import {action} from 'mobx';
import {DomainStore} from 'shared/store';

class MyExpensesState {
  store = new DomainStore();

  @action async removeExpenseRequest(request) {
    await this.store.destroy(request);
  }
}

export default MyExpensesState;
